import { useEffect, useState } from "react";
import { APIHandlerV2 } from "hooks/api-handler-v2";
export function UseApiCallV2({
  url,
  method,
  paramsData,
  skip = false,
  isM2CBackendUrl = false,
  isSimulationUrl = false,
}: any) {
  const [data, setData] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<any>();

  useEffect(() => {
    if (!skip) {
      getData();
    }
  }, [skip]);

  async function getData() {
    try {
      setIsLoading(true);
      const data: any = await APIHandlerV2({
        method,
        url,
        data: paramsData,
        isM2CBackendUrl,
        isSimulationUrl,
      });

      setData(data);
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  }

  function refetch() {
    getData();
  }

  return { data, isLoading, error, refetch };
}
